var e = /* @__PURE__ */ ((r) => (r.PartyMode = "party-mode", r.ListeningMode = "listening-mode", r))(e || {});
const D = ["everyone", "owner", "owner_same_domain"];
var d = /* @__PURE__ */ ((r) => (r.CANCELLED = "cancelled", r.SCHEDULED = "scheduled", r.IN_SESSION = "active", r.ENDED = "ended", r.ARCHIVED = "archived", r))(d || {}), E = /* @__PURE__ */ ((r) => (r.IN_REVIEW = "inReview", r.GRANTED = "granted", r.IGNORED = "ignored", r.DENIED = "denied", r))(E || {}), n = /* @__PURE__ */ ((r) => (r.Google = "google", r))(n || {});
export {
  e as MeetingType,
  E as SessionAccessRuleStatus,
  n as SessionCalendarType,
  d as SessionStatus,
  D as summaryEmailRecipients
};
